export const GLOBAL_ACTION = "GLOBAL_ACTION";
